import { render, staticRenderFns } from "./VlIndexShowFilters.vue?vue&type=template&id=390f7cfe&scoped=true&"
import script from "./VlIndexShowFilters.vue?vue&type=script&lang=js&"
export * from "./VlIndexShowFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390f7cfe",
  null
  
)

export default component.exports